import { render } from "./RecebimentoMercadoriasListagem.vue?vue&type=template&id=610bbd9a&scoped=true&ts=true"
import script from "./RecebimentoMercadoriasListagem.vue?vue&type=script&lang=ts"
export * from "./RecebimentoMercadoriasListagem.vue?vue&type=script&lang=ts"

import "./RecebimentoMercadoriasListagem.vue?vue&type=style&index=0&id=610bbd9a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610bbd9a"]])

export default __exports__